import React, { useCallback } from 'react';
import { albums } from '../data';
import * as S from './styles';

const AlbumsMobile: React.FC = () => {
  const handleClick = useCallback((url: string) => {
    window.open(url, '_blank');
  }, []);

  const renderAlbums = useCallback(() => {
    return albums.map((album) => (
      <S.Album key={album.id}>
        <S.AlbumHeader>
          <S.AlbumYear>
            {album.id}
            <span>{album.year}</span>
          </S.AlbumYear>
          <div className="wrapper">
            <S.AlbumArtist>{album.artist}</S.AlbumArtist>
            <S.AlbumTitle dangerouslySetInnerHTML={{ __html: album.title }} />
          </div>
        </S.AlbumHeader>
        <S.AlbumCover src={album.cover} alt={album.title} />
        <S.AlbumDescription
          dangerouslySetInnerHTML={{ __html: album.description }}
        />
        <S.PlayButton onClick={() => handleClick(album.url)}>
          <S.PlayIcon />
          ouça agora
        </S.PlayButton>
      </S.Album>
    ));
  }, [handleClick]);
  return <S.Container>{renderAlbums()}</S.Container>;
};

export default AlbumsMobile;
